import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import { reactivateTeamMemberApi } from '../../API/API'

function* reactivateTeamMemberSaga(params) {
    try {
        const response = yield call(() => reactivateTeamMemberApi(params.payload.id)); 
        yield put({type: types.REACTIVATE_TEAM_MEMBER_REQUESTED_SUCCESS, payload: response.data});
      }
      catch (error) {
        yield put({type: types.REACTIVATE_TEAM_MEMBER_REQUESTED_FAILURE, error});
    }
}

export function* watchReactivateTeamMemberSaga() {
    yield takeEvery(types.REACTIVATE_TEAM_MEMBER_REQUESTED, reactivateTeamMemberSaga);
}